/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */

/**
 * The entry point for Post edit metamox
 */
import "@wpnotes/utils"; // Import once for startup polyfilling (e. g. setimmediate)
import { render } from "react-dom";
import React from "react";
import { MetboxComponent } from "./components";
import { RootStore } from "./store";
import "./style/metabox.scss";

const node = document.getElementById(`user-list-component`);

if (node) {
    render(
        <RootStore.StoreProvider>
            <MetboxComponent />
        </RootStore.StoreProvider>,
        node
    );
}

export * from "@wpnotes/utils";
export * from "./wp-api";
export * from "./store";
